import React from "react";
import styled from "styled-components";
import { Flex, Text } from "../../assets/ui";
import Theme from "../../assets/ui/theme";
import ScrollDown from "../../components/common/ScrolDown";

const StyledSectionWrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;

  & span {
    white-space: nowrap;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    padding: 0 24px;
    align-items: flex-start;
    max-width: 1280px;
    margin: 0 auto;
  }

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    padding: 0 80px;
  }
`;

const BannerWorkWithUs = () => {
  return (
    <StyledSectionWrapper>
      <Flex
        fontWeight="bold"
        flexDirection={["column", "row"]}
        alignItems={["center", "flex-start"]}
        marginBottom={["170px", null, null, "180px"]}
        flexWrap="wrap"
        lineHeight={["42px", "72px"]}
        fontSize={["36px", "72px"]}
        color={Theme.colors.white}
      >
        <Text> Start a new </Text>
        <Text color={Theme.colors.mainPink} marginLeft={["0", "10px"]}>
          {" "}
          journey.
        </Text>
        <Text width="100%"> Join our family</Text>
      </Flex>
      <ScrollDown />
    </StyledSectionWrapper>
  );
};

export default BannerWorkWithUs;
